import { useTranslation, Trans } from 'react-i18next';
import commissionBannerStyles from '@modules/refer-and-earn/presentation/pages/List/features/CommissionBanner/styles';
import {
  Flex, Title, Text
} from '@huspy/briks-web';
import { Timeline } from '@mantine/core';

const { container, commission, stepsContainer } = commissionBannerStyles;

export const CommissionBanner = () => {
  const { t } = useTranslation();
  return (
    <Flex justify='space-between' className={ container }>
      <Flex direction='column' justify='center'>
        <Text size='lg' color='text-primary'>
          <Trans i18nKey='referAndEarn.list.commissionBanner.message'>
            TEXT_PLACEOHOLDER
            <Title
              size='h5'
              weight='semiBold'
              className={ commission }
              style={ { WebkitBackgroundClip: 'text' } }
            >
              COMMISSION_VALUE
            </Title>
            TEXT_PLACEOHOLDER
          </Trans>
        </Text>
      </Flex>
      <Flex direction='column' justify='center' className={ stepsContainer }>
        <Timeline bulletSize={ 24 } lineWidth={ 2 } data-testid='refer-steps-timeline'>
          {[1, 2, 3].map((value, index) => (
            <Timeline.Item key={ value } bullet={ <Text size='sm'>{value}</Text> } lineVariant='dashed'>
              <Text size='md'>{t(`referAndEarn.list.commissionBanner.steps.${index}`)}</Text>
            </Timeline.Item>
          ))}
        </Timeline>
      </Flex>
    </Flex>
  );
};
